import type AreaAnalysis from "../AreaAnalysis"
import type Area from "../Area"
import type AnalysisBuilder from "./AnalysisBuilder"

export class SalesCountAnalysisBuilder implements AnalysisBuilder {
	build(analysis: AreaAnalysis, area: Area): string {
		const area_name = area.getDisplayName()
		const sales_count = analysis.one_year_sales_count
		if (!sales_count) return ""

		if (sales_count == 0) return ""
		if (sales_count < 15) return "Statistics in this report are subject to higher levels of uncertainty due to the low sales volume of " + sales_count + " sales in the last year."
		if (sales_count < 25) return "The sales volume of " + sales_count + " sales over the last year is moderate, providing a reasonable basis for area pricing in " + area_name + "."
		if (sales_count < 50) return "Data in this report is based on a high sales volume of " + sales_count + " sales in the last year."
		return "Sales activity reached a high of " + sales_count + " sales in the last year, giving a reliable picture of market values in " + area_name + "."
	}
}